<template>
  <div style="padding-left: 100px; padding-right: 100px;">

      <div style="width: 100%; margin-bottom: 10px">
        <el-row style="margin-top: 20px; height: auto;">
          <el-col :span="10">
            <el-carousel style="width: 500px; margin: auto">
              <el-carousel-item v-for="item in customerPictures" :key="item.id">
                <el-image style="height: 340px; width: 500px" :src="item.url" />
              </el-carousel-item>
            </el-carousel>
          </el-col>

          <el-col :span="14">
            <el-form :model="busData" style="margin-left: 50px; height: auto">
              <el-form-item label-width="100px" >
                <el-text style="font-size: 28px; font-weight: bold">{{ busData.name }}</el-text>
              </el-form-item>
              <el-form-item label-width="100px" >
                <el-text style="font-size: 20px;">{{ busData.EnglishName }}</el-text>
              </el-form-item>

              <el-row>
                <el-col :span="15">
                  <el-form-item label-width="100px" label="城市：" style="width: 400px">
                    <el-text >{{ busData.city }}</el-text>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label-width="100px" label="行业：" style="width: 400px">
                    <el-text>{{ busData.industry }}</el-text>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="15">
                  <el-form-item label-width="100px" label="地址：">
                    <el-text>{{ busData.address }}</el-text>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label-width="100px" label="网址：">
                    <el-text>{{ busData.website }}</el-text>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-form-item label-width="100px" label="产品：">
                <el-text>{{ busData.productInfo }}</el-text>
              </el-form-item>

              <el-col >
                <el-form-item label-width="100px" label="简介：">
                  <el-scrollbar max-height="90px" always>{{ busData.introduce }}</el-scrollbar>
                </el-form-item>
              </el-col>
              <el-col >
                <el-form-item label-width="100px" label="经营范围：">
                  <el-scrollbar max-height="90px" always>{{ busData.businessScope }}</el-scrollbar>
                </el-form-item>
              </el-col>

              <el-form-item label-width="100px" label="集成系统：">
                <el-text>{{ busData.integrateSystems }}</el-text>
              </el-form-item>
            </el-form>

          </el-col>

        </el-row>
      </div>
      <el-form style="margin-bottom: 100px">
        <hr class="hr">
        <el-form-item style=" padding-top: 10px;" label="案例关联产品：" label-width="200px" >
          <div style="width: 1200px;">
            <el-row >
              <el-col style="text-align: center"  v-for="item in caseProductList" :span="8">{{ item.name }}</el-col>
            </el-row>
          </div>
        </el-form-item>
        <hr class="hr">
        <el-form-item style=" padding-top: 10px;" label="案例展示：" label-width="200px" >
          <div style="width: 1200px;">
            <el-row >
              <el-col tabindex="1" style="text-align: center;" :span="8" v-for="item in caseList" >
                <el-button  @click="showCase(item)">{{ item.name }}</el-button>
              </el-col>
            </el-row>
          </div>

        </el-form-item>
        <div>
          <el-tabs v-model="tabName" class="tabs">
            <el-tab-pane label="案例详情" name="caseDetail">
              <div v-if="caseType != 'video' && caseType != 'case_video'">
                <pdf v-for="i in numPages"
                     :key="i"
                     :src="src"
                     :page="i"
                ></pdf>
              </div>

              <div  v-if="caseType == 'video' || caseType == 'case_video'" class="myVideo">
                <video
                    id="myVideo"
                    :src="videoUrl"
                    :controls=true
                    oncontextmenu="return false"
                    style="width: 100%;height: 100%;object-fit:fill;border: 1px solid lightgrey" >
                </video>
              </div>
            </el-tab-pane>
            <el-tab-pane label="相关资料" name="aboutCase">
              <el-table style="margin: auto; width: 50%" :data="aboutCaseList" stripe>
                <el-table-column align="center" width="80" prop="idx" label="序号" />
                <el-table-column align="left" prop="name" label="名称" />
                <el-table-column align="center" label="操作">
                  <template #default="scope">
                  <el-button type="text" @click="showFile(scope.row)" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-form>
  </div>
</template>

<script>

import pdf from 'vue3-pdf'
import {Burger} from "@element-plus/icons-vue";
export default {
  name: "CaseCompanyDetails",
  components: {Burger,pdf},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      PDFurl:'',
      tabName:'',
      caseType:'',
      videoUrl: '',
      src: {},
      numPages: undefined,
      customerPictures:[],
      caseProductList:[],
      caseList:[],
      fileTypeList:[],
      busData:{
        name:'',
        EnglishName:'',
        city:'',
        industry:'',
        address:'',
        website:'',
        productInfo:'',
        introduce:'',
        businessScope:'',
        buyNumber:0,
        integrateSystems:'',

      },
      aboutCaseList:[],

    }
  },
  created(){
    let id = this.parentData;
    this.getCustomerPicture(id)
    this.getCompanyDetail(id)
    this.getCaseInfo(id)
    this.getCaseProduct(id)

  },
  methods:{
    async getCustomerPicture(id){
      let params = {customerId : id}
      this.customerPictures = await this.$http('caseLibraryService.getCustomerPictures',params)
    },
    async showCase(item){
      this.caseType = item.case_type
      if('video' !== this.caseType && 'case_video' !== this.caseType){
        this.showCasePDF(item.id)
      }else if ('video' === this.caseType){
        this.videoUrl = item.video_file_url
        this.tabName = 'caseDetail';
      }else {
        this.videoUrl = item.case_video_file_url
        this.tabName = 'caseDetail';
      }
    },
    //根据案例id获取对应的pdf信息
    async showCasePDF(id){
      let params ={caseId : id}
      this.tabName = 'caseDetail';
      this.PDFurl = await this.$http('caseLibraryService.getCasePdfUrl',params)
      this.src = pdf.createLoadingTask(this.PDFurl);
      this.src.promise.then(pdf => {
        this.numPages = pdf.numPages;
      });
      await this.getCompanyFiles(id)
    },
    //获取与该企业所有案例相关的产品信息
    async getCaseProduct(id){
      let params = {companyId : id}
      this.caseProductList = await this.$http('caseLibraryService.getCaseProductList',params)
    },

    //案例信息
    async getCaseInfo(id){
      let params ={customerId : id}
      this.caseList = await this.$http('caseLibraryService.getCaseById',params)

      if(this.caseList.length >= 1){
        this.showCase(this.caseList[0])
      }

    },
    //根据企业id获取相关企业信息
    async getCompanyDetail(id){
      let params ={customerId : id}
      this.busData = await this.$http('caseLibraryService.getCompanyDetailById',params)
    },
    //根据企业id查询出企业所有文件
    async getCompanyFiles(id){
      let params ={caseId : id}
      this.aboutCaseList = await this.$http('caseLibraryService.getCompanyFiles',params)

    },
    //展示当前数据打开当前数据信息
    showFile(data){
      window.open(data.url);
    }

  }

}
</script>

<style scoped>

.hr{
  border:none;
  border-top:2px solid #01bbe5;
}

.list-item el-img{
  height:500px;
  width:300px;
}

.tabs :deep(.el-tabs__nav-scroll){
  width: 15%;
  margin: 0 auto!important;
}
.tab :deep(.el-tabs__nav-scroll){
  width: 200px;
  float: right;
}
.el-carousel :deep(.el-carousel__container){
  height: 350px;
}
.el-form-item{
  margin-bottom: 5px;
}


</style>